import { endPageTransition, startPageTransition } from "@/apiUtils/pageLoadingUtils";
import ArrowLeftIcon from "@/assets/icons/arrowLeft.svg?react";
import { cn } from "@/lib/tailwind";
import React from "react";

interface IProps {
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
  onGoBack: () => void | Promise<void>;
}

const Navigation = ({ className, onGoBack, children, disabled }: IProps) => {
  const handleGoBack = async () => {
    startPageTransition(false);
    await onGoBack();
    endPageTransition();
  };

  return (
    <div className={cn("mb-4 flex items-center gap-3 font-semibold", className)}>
      <button disabled={disabled} onClick={handleGoBack} className="h-5 w-5 cursor-pointer">
        <ArrowLeftIcon />
      </button>
      {typeof children === "string" ? <span className="text-sm">{children}</span> : children}
    </div>
  );
};

export default Navigation;
